/*
 *
 * SettingsLanguagePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 23-Apr-2025
*/
import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.confirm'
      defaultMessage='Conferma'
    />
  ),
  title: (
    <PortalMessage
      id='t.app.settings.switchLanguage.title'
      defaultMessage='Lingua'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.settingsLanguage'
      defaultMessage='Seleziona la lingua che desideri impostare'
    />
  ),
  languageChangedToast: (
    <PortalMessage
      id='t.app.merchantLanguageSelect.languageChangedToast'
      defaultMessage='Lingua modificata con successo.'
    />
  )
}

export default formattedMessage
